<template>
  <el-form label-width="200px" @submit.native.prevent>
    <el-form-item label="人群包">
      <el-radio-group v-model="targetingParam.audienceMode" @change="onAudienceModeChange">
        <el-radio-button ghost border label="NONE">不限</el-radio-button>
        <el-radio-button ghost border label="AUDIENCE">定向排除人群</el-radio-button>
      </el-radio-group>

      <div style="margin-top: 10px; max-width: 1100px" v-if="targetingParam.audienceMode === 'AUDIENCE'">
        <AudiencesTable v-model="polulations" :data="audienceData" :accounts="[accounts]" />
      </div>
    </el-form-item>

    <el-form-item label="地域">
      <el-radio-group v-model="targetingParam.district">
        <el-radio-button ghost label="NONE">不限</el-radio-button>
        <el-radio-button ghost label="CITY">按省市</el-radio-button>
      </el-radio-group>

      <div style="margin-top: 10px" v-if="targetingParam.district === 'CITY'">
        <CascaderSelector
          v-model="targetingParam.region"
          :options="cityData"
          :props="{ multiple: true, value: 'id', label: 'value' }"
        ></CascaderSelector>
      </div>
    </el-form-item>

    <el-form-item label="性别">
      <el-radio-group v-model="targetingParam.sex">
        <el-radio-button ghost label="0">不限</el-radio-button>
        <el-radio-button ghost label="1">女</el-radio-button>
        <el-radio-button ghost label="2">男</el-radio-button>
      </el-radio-group>
    </el-form-item>

    <el-form-item label="年龄">
      <el-radio-group v-model="targetingParam.ageMode">
        <el-radio-button ghost label="NONE">不限</el-radio-button>
        <el-radio-button ghost label="RANGE">指定年龄段</el-radio-button>
        <el-radio-button ghost label="CUSTOM">自定义年龄</el-radio-button>
      </el-radio-group>

      <!-- 年龄段 -->
      <div style="margin-top: 10px" v-if="targetingParam.ageMode === 'RANGE'">
        <el-checkbox-group v-model="targetingParam.age">
          <el-checkbox label="1">18岁以下</el-checkbox>
          <el-checkbox label="2">18-24岁</el-checkbox>
          <el-checkbox label="3">25-34岁</el-checkbox>
          <el-checkbox label="4">35-44岁</el-checkbox>
          <el-checkbox label="5">45-54岁</el-checkbox>
          <el-checkbox label="6">54岁以上</el-checkbox>
        </el-checkbox-group>
      </div>

      <!-- 自定义 -->
      <div style="margin-top: 10px" v-if="targetingParam.ageMode === 'CUSTOM'">
        <RangeAge v-model="targetingParam.customAge" :offset="9" />
      </div>
    </el-form-item>

    <el-form-item label="兴趣">
      <el-radio-group v-model="targetingParam.interestType" @change="onInterestTypeChange">
        <el-radio-button ghost label="NONE">不限</el-radio-button>
        <el-radio-button ghost label="CUSTOM" :disabled="hasCrowdInclude">按兴趣分类</el-radio-button>
      </el-radio-group>

      <div style="margin-top: 10px" v-if="targetingParam.interestType === 'CUSTOM'">
        <CascaderSelector
          v-model="targetingParam.newInterests"
          filterable
          :options="interestData"
          :props="{ multiple: true, value: 'id', label: 'value' }"
        ></CascaderSelector>
      </div>
    </el-form-item>

    <el-form-item label="商业意图">
      <el-radio-group v-model="targetingParam.keywordsType" @change="onKeywordChange">
        <el-radio-button ghost label="NONE">不限</el-radio-button>
        <el-radio-button ghost label="ADD" :disabled="hasCrowdInclude">添加意图词</el-radio-button>
      </el-radio-group>

      <div style="margin-top: 10px" v-if="targetingParam.keywordsType === 'ADD'">
        <KeywordInterest
          v-model="targetingParam.keywordsArr"
          :account="formData.ad_account_id"
          @on-select="onAppendInterestWords"
          @on-delete="onDeleteSelectedWord"
          @on-clear="onInterestClear"
        />

        <div style="margin-top: 10px">
          <span>用户行为&ensp;</span>
          <el-radio-group v-model="targetingParam.keywordsExtend">
            <el-radio-button ghost label="1">全网行为</el-radio-button>
            <el-radio-button ghost label="2">历史搜索</el-radio-button>
          </el-radio-group>
        </div>
      </div>
    </el-form-item>

    <!-- APP定向 -->
    <el-form-item label="APP定向" v-if="formData.innerForm.ch_platform_id === 1">
      <el-radio-group v-model="targetingParam.appType" @change="onAppTypeChange">
        <el-radio-button ghost label="all">不限</el-radio-button>
        <el-radio-button ghost label="category">按APP分类</el-radio-button>
        <el-radio-button ghost label="custom">按APP名称</el-radio-button>
      </el-radio-group>
    </el-form-item>

    <el-form-item label="定向逻辑" v-if="['category', 'custom'].includes(targetingParam.appType)">
      <div>
        <mixcheck v-model="targetingParam.appBehavior">
          <radio-item :label="2">安装</radio-item>
          <radio-item :label="4">排除安装</radio-item>
        </mixcheck>
      </div>

      <CascaderSelector
        v-if="targetingParam.appType === 'category'"
        v-model="targetingParam.appCateArr"
        :options="appTargetingData"
        :props="{ multiple: true, value: 'id', label: 'value' }"
      ></CascaderSelector>

      <RemoteSearchSelector
        v-if="targetingParam.appType === 'custom'"
        v-model="targetingParam.appNameArr"
        :data="remoteAppData"
        :loading="remoteQuering"
        :remote-method="appTargetingRemoteQuery"
        :max="100"
      />
    </el-form-item>

    <el-form-item label="操作系统">
      <el-radio-group v-model="targetingParam.device" disabled>
        <el-radio-button ghost label="0">不限</el-radio-button>
        <el-radio-button ghost label="2">Android</el-radio-button>
        <el-radio-button ghost label="1">iOS</el-radio-button>
      </el-radio-group>
    </el-form-item>

    <el-form-item label="IOS版本" v-if="targetingParam.device === '1'">
      <Mixcheck v-model="targetingParam.iosVersion">
        <radio-item label="0">不限</radio-item>
        <check-item v-for="item in iosVersions" :label="item.key" :key="item.key">
          {{ item.label }}
        </check-item>
      </Mixcheck>
    </el-form-item>

    <el-form-item label="安卓版本" v-if="targetingParam.device === '2'">
      <Mixcheck v-model="targetingParam.androidVersion">
        <radio-item label="0">不限</radio-item>
        <check-item v-for="item in androidVersions" :label="item.key" :key="item.key">
          {{ item.label }}
        </check-item>
      </Mixcheck>
    </el-form-item>

    <el-form-item label="网络">
      <el-radio-group v-model="targetingParam.net">
        <el-radio-button ghost label="0">不限</el-radio-button>
        <el-radio-button ghost label="1">WIFI</el-radio-button>
        <el-radio-button ghost label="2">数据网络</el-radio-button>
      </el-radio-group>
    </el-form-item>

    <el-form-item label="人生阶段">
      <Mixcheck v-model="targetingParam.lifeStage" type="button">
        <radio-item label="0">不限</radio-item>
        <check-item label="1">未婚</check-item>
        <check-item label="2">已婚</check-item>
        <check-item label="3">孕期</check-item>
        <check-item label="4">家有儿女</check-item>
      </Mixcheck>
    </el-form-item>

    <el-form-item label="学历">
      <Mixcheck v-model="targetingParam.education">
        <radio-item label="0">不限</radio-item>
        <check-item label="1">大学及以上</check-item>
        <check-item label="2">高中及以下</check-item>
        <check-item label="3">大专</check-item>
      </Mixcheck>
    </el-form-item>

    <el-form-item label="智能扩量">
      <el-switch v-model="targetingParam.autoExpansion" active-value="1" inactive-value="0"></el-switch>
    </el-form-item>

    <el-form-item label="排除已转化用户">
      <el-radio-group v-model="targetingParam.excludeTrans">
        <el-radio-button ghost label="0">不限</el-radio-button>
        <el-radio-button ghost label="3">同单元</el-radio-button>
        <el-radio-button ghost label="2">同计划</el-radio-button>
        <el-radio-button ghost label="1">同账户</el-radio-button>
      </el-radio-group>
    </el-form-item>
  </el-form>
</template>
<script>
import { isArray } from '@/common/js/utils'
import { getAudience, getAppIdName } from '@/api/baidu.model.js'

// import CascaderSelector from '@/components/cascader-select/index.vue'
import CascaderSelector from '@/components/cascader-select/index.vue'
import RemoteSearchSelector from '@/components/remote-search-table'

import RangeAge from '@/components/range/baidu-age.vue'
import KeywordInterest from '@/views/create/baidu_local/components/keywordinterest'
import AudiencesTable from '@/views/edit/kuaishou/components/audiences-table'

import Mixcheck from '@/components/mixcheck'
import CheckItem from '@/components/mixcheck/check-item'
import RadioItem from '@/components/mixcheck/radio-item'

export default {
  components: {
    AudiencesTable,
    Mixcheck,
    CheckItem,
    RadioItem,
    CascaderSelector,
    RemoteSearchSelector,
    RangeAge,
    KeywordInterest
  },
  data() {
    return {
      aaccc: [5000, 510201, 580101],
      appTargetingData: [], // app定向数据
      remoteAppData: [], // app名称分类远程搜索数据
      audienceData: [], // 人群包数据
      cityData: [],
      interestData: [],
      androidVersions: [],
      iosVersions: [],
      remoteQuering: false
    }
  },
  computed: {
    // 是否选择了人群定向包，如果选择了，禁用兴趣、意图词定向
    hasCrowdInclude() {
      return !!this.targetingParam.polulations.includes.length
    },
    formData() {
      return this.$store.getters['Baidu/currTaskParams']
    },
    targetingForm: {
      get() {
        return this.formData.targetingForm
      },
      set(form) {
        this.$store.commit('Baidu/UPDATE_TARGETING_FORM', form)
      }
    },
    accounts() {
      const { ad_account_id, ad_account_name } = this.formData
      return { id: ad_account_id, name: ad_account_name }
    },
    targetingParam: {
      get() {
        return this.targetingForm?.targetingParam || {}
      },
      set(params) {
        this.$store.commit('Baidu/UPDATE_CURR_TARGETING_PARAMS', params)
      }
    },
    /**
     * @description: 人群包model，转换结构支持组件多账号选择人群包
     */
    polulations: {
      get() {
        const accountId = this.accounts.id
        return {
          [accountId]: this.targetingParam.polulations
        }
      },
      set(newModel) {
        const newForm = this.targetingForm
        newForm.targetingParam.polulations = newModel
        this.targetingForm = newForm
      }
    }
  },
  methods: {
    /**
     * @description: app定向按名称分类的远程搜索方法
     * @return {*}
     */
    appTargetingRemoteQuery(querystr) {
      const params = { ad_account_id: this.formData.ad_account_id, query: querystr, page: 1, pageSize: 200 }
      this.remoteQuering = true
      getAppIdName(params)
        .then((data) => {
          this.remoteQuering = false
          if (isArray(data?.data)) {
            this.remoteAppData = data.data
          }
        })
        .catch(() => {
          this.remoteQuering = false
        })
    },
    /**
     * @description: 切换app定向类型时，修改appBehavior的值，app定向为不限时appBehavior不提交
     * @param {*} type
     */
    onAppTypeChange(type) {
      const newParams = this.targetingParam
      newParams.appBehavior = type === 'all' ? undefined : 2
      this.targetingParam = newParams
    },
    /**
     * @description: 百度人群包数据状态变更
     * @conditions: 选中兴趣定向，人群包不能选定向，只能排除
     * @conditions: 选中添加意图词，人群包不能选定向，只能排除
     */
    onAudienceModeChange() {
      const { interestType, keywordsType } = this.targetingParam
      this.audienceData = this.audienceData.map((au) => {
        const newRow = { ...au, includesDisabled: false, excludesDisabled: false }
        // 选中兴趣定向、 选中添加意图词
        newRow.includesDisabled = interestType === 'CUSTOM' || keywordsType === 'ADD'
        return newRow
      })
    },
    onKeywordChange() {
      this.onAudienceModeChange()
    },
    onInterestTypeChange() {
      this.onAudienceModeChange()
    },

    /**
     * @description: 删除单个已添加商业意图词
     */
    onDeleteSelectedWord(word) {
      if (!word) return
      const newParams = this.targetingParam
      newParams.keywordsArr = newParams.keywordsArr.filter((w) => w !== word)
      this.targetingParam = newParams
    },
    /**
     * @description: 添加商业意图词
     */
    onAppendInterestWords(words) {
      const newParams = this.targetingParam
      newParams.keywordsArr = newParams.keywordsArr.concat(words)

      this.targetingParam = newParams
    },
    /**
     * @description: 清除已选商业意图词
     */
    onInterestClear() {
      const newParams = this.targetingParam
      newParams.keywordsArr = []

      this.targetingParam = newParams
    },
    formValidate() {
      return Promise.resolve()
    },

    getPageInitData() {
      // 城市列表数据
      fetch('/data/baidu_cities.json')
        .then((res) => res.json())
        .then((cities) => (this.cityData = cities))

      // 兴趣列表数据
      fetch('/data/baidu_new_interests.json')
        .then((res) => res.json())
        .then((interests) => (this.interestData = interests))

      // app定向列表数据
      fetch('/data/baidu_app_cate.json')
        .then((res) => res.json())
        .then((apps) => (this.appTargetingData = apps))

      // 安卓操作系统版本列表数据
      fetch('/data/baidu_android_versions.json')
        .then((res) => res.json())
        .then((versions) => (this.androidVersions = versions))

      // ios操作系统版本列表数据
      fetch('/data/baidu_ios_versions.json')
        .then((res) => res.json())
        .then((versions) => (this.iosVersions = versions))

      // 人群包数据
      if (this.accounts.id) {
        getAudience({ ad_account_id: this.accounts.id }).then((audienceData) => {
          if (isArray(audienceData)) {
            this.audienceData = audienceData.map((au) => ({
              ...au,
              check: null,
              includesDisabled: false,
              excludesDisabled: false
            }))
          }
        })
      }
    }
  },
  created() {
    this.getPageInitData()
  }
}
</script>
<style lang="scss" scoped></style>
